/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Teams_Stat_No_LeaderInputs */

const cs_settings_teams_stat_no_leader = /** @type {(inputs: Settings_Teams_Stat_No_LeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bez vedoucího`)
};

const en_settings_teams_stat_no_leader = /** @type {(inputs: Settings_Teams_Stat_No_LeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Without a leader`)
};

/**
* | output |
* | --- |
* | "Without a leader" |
*
* @param {Settings_Teams_Stat_No_LeaderInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_teams_stat_no_leader = /** @type {((inputs?: Settings_Teams_Stat_No_LeaderInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Teams_Stat_No_LeaderInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_teams_stat_no_leader(inputs)
	return cs_settings_teams_stat_no_leader(inputs)
});